import { AuthService } from './authService';
import { extractApiError } from '../utils/apiError';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Response from running the standard replenishment rule group ("Opprett påfylling").
 * Mirrors RunReplenishmentResponse in BizClick.WMS.Shared.
 */
export interface RunReplenishmentResponse {
  success: boolean;
  replenishmentNeeded: boolean;
  stcOrderNo: number | null;
  processedCount: number;
  totalLineCount: number;
  ruleGroupId: number;
  message: string | null;
  errorMessage: string | null;
}

class ReplenishmentService {
  /**
   * Run the standard replenishment rule group (SystemSetup.StdReplenishmentRuleGroupID).
   * Creates a replenishment order (StcIntRelOrder, TransType=2) for pick bins below
   * their minimum level. Manager/administrator only.
   */
  async runReplenishment(): Promise<RunReplenishmentResponse> {
    const response = await AuthService.authenticatedPost(
      `${API_BASE_URL}/replenishment/run`,
      {}
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      // 422/404 carry a RunReplenishmentResponse body with errorMessage — surface it
      if (errorData && typeof errorData.success === 'boolean') {
        return errorData as RunReplenishmentResponse;
      }
      throw new Error(extractApiError(errorData, response, 'Kunne ikke opprette påfylling'));
    }

    return await response.json();
  }
}

export const replenishmentService = new ReplenishmentService();
